import React from 'react';
import SubNavigation from '../sub-navigation';
import { TabItem } from '../sub-navigation/types';

const tabs: TabItem[] = [
  { label: 'All Trips', to: '' },
  { label: 'Sold Trips', to: 'sold' },
];

const TripsSubNavigationContainer = () => (
  <SubNavigation
    profile={{
      primary: 'Trips',
      primaryTypographyProps: { variant: 'h3' },
    }}
    tabs={tabs}
  />
);
export default TripsSubNavigationContainer;
